export default __webpack_public_path__ + "static/media/E11BBeiUYAQflRL.bf7008bb.jpg";